import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { path } from "ramda";

import { jjLogger } from "utils/logUtils";
import SearchLinksRepository from "repositories/SearchLinksRepository";

const initialState = {
  searchLinks: null,
};

const searchLinksSlice = createSlice({
  name: "searchLinks",
  initialState,
  reducers: {
    getSearchLinks(state, { payload }) {
      const menuItems = path(["items", 0, "fields", "menuItems"], payload);

      if (!menuItems) {
        jjLogger.log("SearchLinksSlice.js | Header menu is empty");
        return;
      }

      const headerMenu = [];
      for (let index = 0; index < menuItems.length; index += 1) {
        const menu = menuItems[index];

        if (menu?.fields) {
          headerMenu.push({
            id: menu.sys.id,
            name: menu.fields.linkText,
            url: menu.fields.linkTo,
          });
        }
      }

      state.searchLinks = headerMenu;
    },
  },
});

export const { actions } = searchLinksSlice;
export default searchLinksSlice.reducer;

export const useSearchLinksActions = () => {
  const dispatch = useDispatch();

  const getSearchLinks = () => {
    return SearchLinksRepository.getSearchLinks().then(({ data }) => {
      dispatch(searchLinksSlice.actions.getSearchLinks(data));
    });
  };

  return {
    getSearchLinks,
  };
};
